import { Link, useParams } from "react-router-dom";
import { TEAM } from "../data/content";
import "./BioProfile.css";

export default function BioProfile() {
  const { memberId } = useParams();
  const member = TEAM.find((item) => item.id === memberId);

  if (!member) {
    return (
      <main className="bio-page section-pad">
        <div className="container bio-page__empty">
          <h1 className="section-title">Bio Not Found</h1>
          <p className="section-sub">
            The requested bio could not be found. Please return to the team
            section.
          </p>
          <Link to="/" className="btn-primary">
            Back to Home
          </Link>
        </div>
      </main>
    );
  }

  return (
    <main className="bio-page section-pad">
      <div className="container bio-page__content">
        <span className="section-label">Founder Profile</span>
        <h1 className="section-title">{member.name}</h1>
        <p className="bio-page__role">{member.title}</p>

        {member.photo && (
          <div className="bio-page__photo-wrap">
            <img
              src={member.photo}
              alt={member.name}
              className="bio-page__photo"
            />
          </div>
        )}

        <section className="bio-page__section">
          <h2>Bio</h2>
          {(member.bioFull || [member.para1, member.para2]).map((para, i) => (
            <p key={i}>{para}</p>
          ))}
        </section>

        <section className="bio-page__section">
          <h2>Credentials</h2>
          <ul>
            {member.credentials.map((credential) => (
              <li key={credential}>{credential}</li>
            ))}
          </ul>
        </section>

        <section className="bio-page__section">
          <h2>Past Work</h2>
          <ul>
            {(member.pastWork || []).map((work) => (
              <li key={work}>{work}</li>
            ))}
          </ul>
        </section>

        {member.publications && member.publications.length > 0 && (
          <section className="bio-page__section">
            <h2>Publications</h2>
            <ul>
              {member.publications.map((pub) => (
                <li key={pub}>{pub}</li>
              ))}
            </ul>
          </section>
        )}

        {member.manuscripts && member.manuscripts.length > 0 && (
          <section className="bio-page__section">
            <h2>Manuscripts in Progress</h2>
            <h3
              style={{
                fontSize: "1.1rem",
                marginTop: "1rem",
                marginBottom: "0.75rem",
                fontWeight: "600",
              }}
            >
              Peer Review Articles
            </h3>
            <ul>
              {member.manuscripts.map((manuscript) => (
                <li key={manuscript}>{manuscript}</li>
              ))}
            </ul>
          </section>
        )}

        {member.researchExperience && member.researchExperience.length > 0 && (
          <section className="bio-page__section">
            <h2>Research Experience</h2>
            <ul>
              {member.researchExperience.map((research, index) => (
                <li key={index}>
                  <strong>{research.years}</strong> — {research.title}
                </li>
              ))}
            </ul>
          </section>
        )}

        <Link to="/" className="btn-outline">
          Back to Team
        </Link>
      </div>
    </main>
  );
}
